import { useConfigContext } from "@/app";
import { Icon } from "@/components/Icon";
import { MessageIcon } from "@/components/MessageIcon";
import { useUserInfoStore } from "@/stores/userInfo";
import { useCreation, useTitle } from "ahooks";
import { Avatar } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import styles from "./Header.module.scss";
import { SpaceContent } from "./components/SpaceContent";

export default function Header() {
  const navigate = useNavigate();
  const userInfo = useUserInfoStore()((state) => state.userInfo);
  const { getSourcePath } = useConfigContext();
  useTitle("首页", { restoreOnUnmount: true });
  // userName
  const userName = useCreation(() => {
    return userInfo.nickname || userInfo.userName || userInfo.realName;
  }, [userInfo]);

  // avatar
  const userAvatar = useCreation(() => {
    return (
      getSourcePath(userInfo.avatar) ||
      userInfo.avatar ||
      "@/assets/images/avatar.png"
    );
  }, [getSourcePath, userInfo.avatar]);

  // realNameText
  const isRealNameText = useCreation(() => {
    return userInfo.isRealNameAuth ? "已实名" : "您还未实名";
  }, [userInfo.isRealNameAuth]);

  // realNameText
  const isRealNameIcon = useCreation(() => {
    return userInfo.isRealNameAuth ? "verify" : "unverify";
  }, [userInfo.isRealNameAuth]);

  const toUserAvatar = () => {
    navigate("/user_nickname");
  };

  const toUserCentify = () => {
    if (!userInfo.isRealNameAuth) {
      return navigate("/user_centify");
    }
  };


  return (
    <SpaceContent
      left={
        <Avatar
          className={styles.pic}
          src={userAvatar}
          onClick={toUserAvatar}
        />
      }
      right={<MessageIcon />}
    >
      <div className={styles.userName}>
        <div className={styles.userNameText} onClick={toUserAvatar}>
          {userName || "未登录"}
        </div>

        <div className={styles.userDesc} onClick={toUserCentify}>
          <span>{isRealNameText}</span>
          <Icon
            name={isRealNameIcon}
            size={"16px"}
            className={styles.verifyIcon}
          />
        </div>
      </div>
    </SpaceContent>
  );
}
